
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import img from "../../assets/video/unsplash_50GSjnC7qXw.png"
import EventModal from './EventModal';
const AllEventCard = ({ index, eventInfo }) => {
    const [show, setShow] = useState(false)
    const {
        top_banner,
        event_mode,
        event_title,
        event_subtitle,
        event_date,
        event_time,
        card_img,
        ispastevent } = eventInfo.node


    return (
        <div className="mx-2 my-3" >
            <div className="card all-events-card">
                <div className=" position-relative">
                    {event_mode && <h3 className="offline-box position-absolute mt-2 me-2 top-0 end-0"> {event_mode}</h3>}
                    <img src={card_img?.url || img} className="img-fluid w-100 " style={{ height: "150px" }} alt="..."></img>
                </div>
                <div className="card-body mx-1 d-flex flex-column justify-content-between">
                    <div className="d-flex  ">
                        {event_date && <small className="secondary-text ">{event_date}</small>}
                        <small className="secondary-text ps-5">{event_time && event_time}</small>

                    </div>
                    <h6 className=" mt-2">{event_title && event_title}</h6>
                    <p className="text-muted">{event_subtitle && event_subtitle}</p>
                    {ispastevent ?
                        <Link to={`/event/${eventInfo.node._meta.uid}`} className=" m-0 p-0 view-details text-decoration-none">View Details  </Link> :
                        <a onClick={() => setShow(true)} className=" m-0 p-0 pinter-cursor view-details text-decoration-none">View Details  </a>
                    }
                    <EventModal show={show} setShow={setShow} info={eventInfo} />
                </div>
            </div>
        </div>
    );
};

export default AllEventCard;